// Mock data for Monatiz Digital website

export const companyInfo = {
  name: "Monatiz Digital",
  tagline: "Digital Content Production & Distribution",
  description: "We produce and distribute high-quality content across Facebook and YouTube platforms, maximizing ad revenue through data-driven content strategies",
  email: "contact@monatizdigital.com",
  phone: "(+852) 7027 1040",
  address: "8/F., CHINA HONG KONG TOWER, 8-12 HENNESSY ROAD, WAN CHAI, HONG KONG"
};

export const services = [
  {
    id: 1,
    title: "Facebook Content Operations",
    description: "We produce and manage content across 200+ Facebook Fanpages, optimizing for maximum ad revenue and audience engagement.",
    features: [
      "Mass content production for 200+ Fanpages",
      "Data-driven content optimization",
      "Ad revenue management",
      "Platform algorithm expertise"
    ],
    image: "https://customer-assets.emergentagent.com/job_monatiz-digital/artifacts/mbg1rspv_IMG_20251115_214114_053.jpg"
  },
  {
    id: 2,
    title: "YouTube Content Operations",
    description: "Operating 100+ YouTube channels with professional video production, delivering consistent content output and AdSense revenue.",
    features: [
      "Video production for 100+ Channels",
      "YouTube SEO and optimization",
      "AdSense revenue maximization",
      "Content scheduling and distribution"
    ],
    image: "https://images.unsplash.com/photo-1528109966604-5a6a4a964e8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHx2aWRlbyUyMG1hcmtldGluZ3xlbnwwfHx8fDE3NjMyMTc4OTB8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Content Studio & Production",
    description: "Our in-house production team creates high-quality content at scale, backed by advanced analytics and market research.",
    features: [
      "Professional content production team",
      "Data analytics and trend monitoring",
      "Multi-format content creation",
      "Quality control and optimization"
    ],
    image: "https://images.unsplash.com/photo-1726066012749-f81bf4422d4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxjb250ZW50JTIwY3JlYXRpb258ZW58MHx8fHwxNzYzMTk3ODk2fDA&ixlib=rb-4.1.0&q=85"
  }
];

export const stats = [
  {
    id: 1,
    value: "200+",
    label: "Facebook Fanpage"
  },
  {
    id: 2,
    value: "100+",
    label: "Youtube Channel"
  },
  {
    id: 3,
    value: "50M+",
    label: "Monthly Reach"
  },
  {
    id: 4,
    value: "98%",
    label: "Satisfaction Rate"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "John Smith",
    position: "CEO & Founder",
    description: "10+ years of experience in digital marketing"
  },
  {
    id: 2,
    name: "Sarah Johnson",
    position: "Head of Content Strategy",
    description: "Content strategy expert with over 8 years of experience"
  },
  {
    id: 3,
    name: "Michael Chen",
    position: "YouTube Specialist",
    description: "Successfully managing over 100 YouTube channels"
  }
];

export const socialLinks = [
  {
    platform: "facebook",
    url: "https://facebook.com/monatizdigital",
    icon: "Facebook"
  },
  {
    platform: "youtube",
    url: "https://youtube.com/@monatizdigital",
    icon: "Youtube"
  },
  {
    platform: "tiktok",
    url: "https://tiktok.com/@monatizdigital",
    icon: "Music" // Using Music icon as TikTok representation
  }
];
